import React from "react"
import styled from "styled-components"
import { color, breakpoint, transition } from "../../../configs/utilities"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"

const NavItemsDesktop = ({ data }) => {
  const location = useLocation().pathname

  return (
    <NavItemsDesktopWrapper>
      {data.map((item, index) => {
        return (
          <div key={index}>
            {!item.node.isSubmenu ? (
              <NavbarItem>
                <Link to={item.node.path} activeClassName="activeNavbarLink">
                  {item.node.text}
                </Link>
              </NavbarItem>
            ) : (
              <NavbarItem>
                <SubmenuParent>
                  <span
                    className={
                      item.node.submenu.some(item => {
                        return item.path.includes(location)
                      }) && location !== "/"
                        ? "submenuParentText activeNavbarLink"
                        : "submenuParentText"
                    }
                  >
                    {item.node.text}
                  </span>
                </SubmenuParent>
                <NavbarSubmenu>
                  {item.node.submenu.map((item, index) => {
                    return (
                      <SubmenuLinkWrapper key={index}>
                        <Link
                          to={item.path}
                          activeClassName="activeSubmenuLink"
                        >
                          {item.text}
                        </Link>
                      </SubmenuLinkWrapper>
                    )
                  })}
                </NavbarSubmenu>
              </NavbarItem>
            )}
          </div>
        )
      })}
    </NavItemsDesktopWrapper>
  )
}

export default NavItemsDesktop

const NavItemsDesktopWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${breakpoint.xl}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    column-gap: 30px;
  }

  /* --------------------------  ACTIVE --------------------------- */
  .activeNavbarLink {
    color: ${color.black};
    font-weight: 600;
    //letter-spacing: 0.05px;
    img {
      opacity: 1;
    }

    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 2px;
      top: 36px;
      transition: ${transition.default};
      background-color: ${color.black};
    }
  }

  .activeSubmenuLink {
    transition: ${transition.default};
    color: ${color.black};
  }
`

const SubmenuParent = styled.div`
  margin-right: 5px;
  line-height: 50px;

  .submenuParentText {
    transition: ${transition.default};
  }
`

const NavbarSubmenu = styled.div`
  position: absolute;
  top: 45px;
  left: -20px;
  flex-direction: column;
  padding: 5px 30px 10px 20px;
  background: ${color.white};
  border-radius: 8px;
  transform: translateX(100%);
  transition: ${transition.default};
  cursor: default;
  display: none;
  opacity: 0;
  background: rgba(252, 252, 252, 1);
`

const SubmenuLinkWrapper = styled.div`
  width: 100%;
  margin: 5px 0;
  line-height: 30px;
`

const NavbarItem = styled.div`
  color: ${color.black};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 50px;
  cursor: pointer;
  font-weight: 400;

  &:hover {
    color: ${color.black};
    img {
      opacity: 1;
    }
  }
  a {
    color: ${color.black};
    white-space: nowrap;
    transition: ${transition.default};
    &:hover {
      color: ${color.black};
    }
  }

  img {
    opacity: 0.5;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    font-size: 14px;
  }

  .angle {
    transition: ${transition.default};
  }
  /* ------------------------- Nav Item Line ------------------------- */
  &:before {
    background: ${color.black};
    content: "";
    inset: 0;
    position: absolute;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.3s ease-in-out;
    z-index: -1;
    height: 1px;
    top: 36px;
  }

  &:hover::before {
    transform: scaleX(1);
    transform-origin: left;
  }

  /* ------------------------- Nav Submenu Animation ------------------------- */
  &:hover {
    ${NavbarSubmenu} {
      display: flex;
      animation: showDropdown 0.3s forwards;
    }

    .angle {
      transform: rotate(-180deg);
    }
  }

  @keyframes showDropdown {
    from {
      clip-path: inset(0 70% 0 30%);
      transform: translateY(50px);
    }

    to {
      clip-path: inset(0 0 0 0);
      transform: translateY(0px);
      opacity: 1;
    }
  }
`
